import { jsx as _jsx } from "react/jsx-runtime";
import withBraze from '../../utils/withBraze';
import { setFrequencyCapping } from '../../utils/frequencyCapping';
import placements from '../../Placements';
import { Logger } from '../../utils/logger';
import { openURLbyTarget } from '../../utils/openURLbyTarget';
import { trackEvent } from '../../utils/tracking';
import { LightBox } from '../../components/LightBox';
const PLACEMENT = placements.PRESCREEN;
const Prescreen = ({ close, payload, section, trackingLibrary, }) => {
    Logger.log('PrescreenConsumer - rendering Message:', payload);
    const openURLbyClickAction = (url, clickAction) => {
        if (clickAction !== 'URI' && !url)
            return close();
        openURLbyTarget(url, payload.openTarget);
        close();
    };
    const onURLButtonClick = (url, target = '_blank', buttonId = 'test_button') => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.trackInAppMessageHTMLClick(PLACEMENT, payload.campaignId, buttonId);
        openURLbyTarget(url, target);
        close();
    };
    const onPrescreenClick = () => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.trackInAppMessageClick(PLACEMENT, payload.campaignId);
        openURLbyClickAction(payload.messageUrl, payload.messageClickAction);
    };
    const onPrescreenButtonClick = () => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.trackInAppMessageButtonClick(PLACEMENT, payload.campaignId);
        payload.buttons.forEach((button) => {
            openURLbyClickAction(button.uri || '', button.clickAction);
        });
    };
    const onPrescreenContentShown = () => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.trackInAppMessageImpression(PLACEMENT, payload.campaignId);
        setFrequencyCapping(section, PLACEMENT);
    };
    const onPrescreenClose = () => {
        trackEvent('brazeClose', {
            brazePlacement: 'prescreen',
            brazeTriggerID: payload === null || payload === void 0 ? void 0 : payload.campaignId,
        });
        close();
    };
    const setBrazeCustomAttribute = (payload) => {
        trackingLibrary === null || trackingLibrary === void 0 ? void 0 : trackingLibrary.setBrazeCustomAttribute(payload);
    };
    return (_jsx(LightBox, { onClose: onPrescreenClose, onPrescreenClick: onPrescreenClick, onPrescreenButtonClick: onPrescreenButtonClick, data: payload, onContentShown: onPrescreenContentShown, onURLButtonClick: onURLButtonClick, setBrazeCustomAttribute: setBrazeCustomAttribute }));
};
const PrescreenConsumer = withBraze(PLACEMENT)(Prescreen);
export { PrescreenConsumer, Prescreen };
//# sourceMappingURL=PrescreenConsumer.js.map